(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSSectorDialogController', SSSectorDialogController);

    SSSectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SSSector'];

    function SSSectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SSSector) {
        var vm = this;

        vm.sSSector = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSSector.id !== null) {
                SSSector.update(vm.sSSector, onSaveSuccess, onSaveError);
            } else {
                SSSector.save(vm.sSSector, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSSectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
